var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vs-table",
        {
          attrs: {
            sst: true,
            currentPage: _vm.currentPage,
            total: _vm.totalItems,
            pagination: "",
            "max-items": _vm.maximoItems == "" ? 1 : _vm.maximoItems,
            search: "",
            data: _vm.registros,
            max: 4,
            maxHeight: "450px"
          },
          on: {
            "change-page": _vm.handleChangePage,
            sort: _vm.handleSort,
            dblSelection: _vm.doubleSelection,
            selected: _vm.handleSelected
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var data = ref.data
                return [
                  _c(
                    "tbody",
                    _vm._l(data, function(tr, indextr) {
                      return _c(
                        "vs-tr",
                        {
                          key: indextr,
                          style: [
                            _vm.colorTd
                              ? {
                                  backgroundColor: _vm.obtenerColor(tr, "days")
                                }
                              : {}
                          ],
                          attrs: { data: tr }
                        },
                        _vm._l(tr, function(td, index2) {
                          return _vm.mostrarColumna(index2)
                            ? _c(
                                "vs-td",
                                {
                                  key: index2,
                                  attrs: { data: td == null ? "0.00" : td }
                                },
                                [
                                  _vm.mostrarColumna(index2) &&
                                  _vm.esCheck(index2)
                                    ? _c("p", [
                                        _c("label", [
                                          _c("input", {
                                            attrs: {
                                              type: "checkbox",
                                              onclick: "return false;"
                                            },
                                            domProps: {
                                              checked: td === "S" ? true : false
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span")
                                        ])
                                      ])
                                    : _vm.mostrarColumna(index2) &&
                                      index2 === "number"
                                    ? _c("p", { staticClass: "number" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.esEditable(index2) && td == null
                                              ? _vm.esTexto(index2)
                                                ? "-"
                                                : "0.00"
                                              : td
                                          )
                                        )
                                      ])
                                    : _vm.mostrarColumna(index2) &&
                                      _vm.EsResumido(index2)
                                    ? _c("p", { staticClass: "resumido" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.esEditable(index2) && td == null
                                              ? _vm.esTexto(index2)
                                                ? "-"
                                                : "0.00"
                                              : td
                                          )
                                        )
                                      ])
                                    : _vm.mostrarColumna(index2)
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.esEditable(index2) && td == null
                                              ? _vm.esTexto(index2)
                                                ? "-"
                                                : "0.00"
                                              : td
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.esEditable(index2)
                                    ? _c(
                                        "template",
                                        { slot: "edit" },
                                        [
                                          _c("vs-input", {
                                            staticClass: "inputx",
                                            on: {
                                              blur: function($event) {
                                                return _vm.guardarColumna(td)
                                              }
                                            },
                                            model: {
                                              value: data[indextr][index2],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  data[indextr],
                                                  index2,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data[indextr][index2]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        }),
                        1
                      )
                    }),
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [
          _c("template", { slot: "header" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("h5", { staticClass: "mt-2" }, [_vm._v(_vm._s(_vm.titulo))]),
                _vm._v(" "),
                _c(
                  "input-field",
                  {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "###",
                        expression: "'###'"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mostrarRegistrosPagina,
                        expression: "mostrarRegistrosPagina"
                      }
                    ],
                    staticClass: "input-field--stretch col-md-2 ml-5 mr-5",
                    attrs: {
                      type: "tel",
                      id: "maximoItems",
                      readonly: !_vm.esEditableCantidadRegistro,
                      placeholder: ""
                    },
                    model: {
                      value: _vm.maximoItems,
                      callback: function($$v) {
                        _vm.maximoItems = $$v
                      },
                      expression: "maximoItems"
                    }
                  },
                  [_c("span", [_vm._v("Registros")])]
                ),
                _vm._v(" "),
                _c(
                  "input-field",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mostrarRegistrosTotales,
                        expression: "mostrarRegistrosTotales"
                      }
                    ],
                    staticClass: "input-field--stretch col-md-2 ml-5 mr-5",
                    attrs: {
                      type: "tel",
                      id: "totalItems",
                      readonly: true,
                      placeholder: ""
                    },
                    model: {
                      value: _vm.totalItems,
                      callback: function($$v) {
                        _vm.totalItems = $$v
                      },
                      expression: "totalItems"
                    }
                  },
                  [_c("span", [_vm._v("Registros")])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mostrarSelectedMultiple,
                        expression: "mostrarSelectedMultiple"
                      }
                    ],
                    staticClass: "select2-field select2-field--stretch"
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        id: "selectedMultiple",
                        label: "descripcion",
                        options: _vm.columnas.filter(function(column) {
                          return column.value != "id"
                        }),
                        multiple: ""
                      },
                      on: { input: _vm.inputSelectedMultiple },
                      model: {
                        value: _vm.form.selectedMultiple,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "selectedMultiple", $$v)
                        },
                        expression: "form.selectedMultiple"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "selectedMultiple" } }, [
                      _vm._v("Filtros:")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "todosSelectedMultiple" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.todosSelectedMultiple,
                        expression: "form.todosSelectedMultiple"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "todosSelectedMultiple",
                      name: "todosSelectedMultiple"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.todosSelectedMultiple)
                        ? _vm._i(_vm.form.todosSelectedMultiple, null) > -1
                        : _vm.form.todosSelectedMultiple
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.form.todosSelectedMultiple,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "todosSelectedMultiple",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "todosSelectedMultiple",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "todosSelectedMultiple", $$c)
                          }
                        },
                        _vm.changeTodosSelectedMultiple
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Todos")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "camposNull" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.camposNull,
                        expression: "form.camposNull"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "camposNull",
                      name: "camposNull"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.camposNull)
                        ? _vm._i(_vm.form.camposNull, null) > -1
                        : _vm.form.camposNull
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.form.camposNull,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "camposNull",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "camposNull",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "camposNull", $$c)
                          }
                        },
                        _vm.changeCamposNull
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Vacíos")])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "thead" },
            _vm._l(_vm.columnasTh, function(columna, indexth) {
              return _c(
                "vs-th",
                {
                  key: indexth,
                  staticStyle: { "min-width": "25%" },
                  style: [
                    _vm.colorTh
                      ? {
                          backgroundColor:
                            _vm.obtenerColor(columna.value, "boxMac") +
                            "!important"
                        }
                      : {}
                  ],
                  attrs: { "sort-key": columna.value }
                },
                [
                  _vm.mostrarColumna(columna.value)
                    ? _c("p", [_vm._v(_vm._s(columna.descripcion))])
                    : _vm._e()
                ]
              )
            }),
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8e24e8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8e24e8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/DynamicTable.vue
// module id = 249
// module chunks = 0